export default __webpack_public_path__ + "static/media/store.aba8790c.jpg";